import React from 'react';
import { useQuery } from '@apollo/client';
import TrackerQuery from './TrackerQuery';

type result = {
  loading: boolean;
  trackerData?: any;
  paidAccess?: any;
};

interface ITrackerConnectorApolloProps {
  children: (result: result) => React.ReactElement;
  date: string;
}

export const TrackerConnectorApollo: React.FC<ITrackerConnectorApolloProps> = ({
  children,
  date,
}) => {
  const { loading, data, error } = useQuery(TrackerQuery, {
    variables: {
      date,
    },
  });

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.trackerData = data.dailyTracker.data;
    result.paidAccess = data.me.paidAccess;
  }

  return children(result);
};

export default TrackerConnectorApollo;
